@if (isActive() && spotlight(); as rect) {
  <div class="tour-overlay">
    <div class="tour-overlay__backdrop"></div>
    <div
      class="tour-overlay__spotlight"
      [style.top.px]="rect.top"
      [style.left.px]="rect.left"
      [style.width.px]="rect.width"
      [style.height.px]="rect.height"
    ></div>
    @if (currentStep(); as step) {
      <div class="tour-overlay__card" [style.top.px]="tooltipTop()" [style.left.px]="tooltipLeft()">
        <h3 class="tour-overlay__title">{{ step.titleKey | transloco }}</h3>
        <p class="tour-overlay__text">{{ step.descriptionKey | transloco }}</p>
        <div class="tour-overlay__footer">
          <span class="tour-overlay__step-count">
            {{ (currentIndex() ?? 0) + 1 }} / {{ steps().length }}
          </span>
          <div class="tour-overlay__actions">
            <button type="button" class="tour-overlay__skip" (click)="onSkip()">
              {{ 'walkthrough.tour.skip' | transloco }}
            </button>
            @if ((currentIndex() ?? 0) > 0) {
              <ccfx-button variant="outline" size="small" (clicked)="onPrev()">
                {{ 'walkthrough.tour.back' | transloco }}
              </ccfx-button>
            }
            <ccfx-button size="small" (clicked)="onNext()">
              {{
                isLastStep()
                  ? ('walkthrough.tour.finish' | transloco)
                  : ('walkthrough.tour.next' | transloco)
              }}
            </ccfx-button>
          </div>
        </div>
      </div>
    }
  </div>
}
